const hexRegex = /^(?:[0-9a-fA-F]{3}){1,2}$/

export const normalizeHexColor = (colorString) => {
  if (!colorString || !colorString.match(hexRegex)) {
    return undefined
  }
  if (colorString.length === 3) {
    return colorString.split('').map((char) => char.repeat(2)).join('')
  }

  return colorString
}
